import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { ImportResponse, Promotion, PromotionId, PromotionDetail, ProductOrganisationId, PromotionHost } from '@portal-front-end/models';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class PromotionsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROMOTION_URL = `${this.apiServer}/promotions`;

    getPromotionById(promotionId: PromotionId): Observable<Promotion> {
        return this.http.get<Promotion>(`${this.PROMOTION_URL}/${promotionId}`);
    }

    getPromotions(orgId: string, hostNotSent: boolean): Observable<Promotion[]> {
        return this.http.post<Promotion[]>(`${this.PROMOTION_URL}/search?organisationId=${orgId}&hostNotSent=${hostNotSent}`, { 
            'searchFilter': {} 
        });
    }
    getAllPromotions(orgId: string): Observable<Promotion[]> {
        return this.http.get<Promotion[]>(`${this.PROMOTION_URL}?organisationId=${orgId}`);
    }

    updatePromotions(object: Update<Promotion>): Observable<Promotion> {
        return this.http.put<Promotion>(`${this.PROMOTION_URL}/${object.changes.promotionId}`, object.changes);
    }

    insertPromotions(object: Promotion): Observable<Promotion> {
        return this.http.post<Promotion>(this.PROMOTION_URL, object);
    }

    deletePromotion(id: string | number) {
        return this.http.delete<string | number>(`${this.PROMOTION_URL}/${id}`)
            .pipe(map(() => id));
    }

    submitForApproval(promotionId: string): Observable<void> {
        return this.http.put<void>(`${this.PROMOTION_URL}/promotion-status`,{
            promotionStatusId: 3,
            promotionIdList: [promotionId]
        }, { responseType: 'text' as 'json'});
    }

    uploadPromotionsFile(promotionId: string, formData: FormData): Observable<ImportResponse> {
        return this.http.post<ImportResponse>(`${this.apiServer}/import-promotions?promotionId=${promotionId}`, formData);
    }
    
    exportPromotionsFile(promotionId: string):Observable<HttpResponse<Blob>> {
        return this.http.get<Blob>(`${this.apiServer}/export-promotions?promotionId=${promotionId}`,
        {
            params: { 'promotionId ': promotionId },
            responseType: 'blob' as 'json',
            observe: 'response'
        });
    }
    
    //Set Host Id for Promotions
    addPromotionsToHost(hostId: string, promotionIds: string[]): Observable<PromotionHost[]> {
        return this.http.post<PromotionHost[]>(`${this.PROMOTION_URL}/refresh-host`,
            {
                "hostId": hostId,
                "promotionIds": promotionIds

            }
        );
    }
    reOpenPromotions(promotionIds: string[]): Observable<PromotionHost[]> {
        return this.http.put<PromotionHost[]>(`${this.PROMOTION_URL}/reopen`,
            {
                "promotionIdList": promotionIds
            }
        );
    }
}
